var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            directives: [
              {
                name: "scroll-lock",
                rawName: "v-scroll-lock",
                value: _vm.isVisible,
                expression: "isVisible"
              }
            ],
            staticClass: "modal"
          },
          [
            _c("div", {
              staticClass: "modal__overlay",
              on: { click: _vm.close }
            }),
            _vm.video
              ? _c(
                  "div",
                  { staticClass: "modal__content modal__content--video" },
                  [
                    _c(
                      "v-button",
                      {
                        staticClass: "modal__close bubble-hover",
                        attrs: { label: "Close Modal" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.close($event)
                          }
                        }
                      },
                      [_c("icon", { attrs: { name: "close", size: "30px" } })],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "modal__content--video__container" },
                      [
                        _c("iframe", {
                          attrs: {
                            width: "853",
                            height: "480",
                            src: _vm.videoUrl,
                            frameborder: "0",
                            allowfullscreen: ""
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "modal__content" },
                  [
                    _c(
                      "v-button",
                      {
                        staticClass: "modal__close bubble-hover",
                        attrs: { label: "Close Modal" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.close($event)
                          }
                        }
                      },
                      [_c("icon", { attrs: { name: "close", size: "30px" } })],
                      1
                    ),
                    _vm._t("content")
                  ],
                  2
                )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }